import { Box, styled } from '@mui/material';
import { type FC, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../../../contexts';

type SidebarLogoProps = {
  full: boolean;
};

const SidebarLogoWrapper = styled(Box)(() => ({
  [`& `]: {
    cursor: 'pointer',
    padding: '24px 26px 19px 26px',
    background: 'linear-gradient( #00a7a8, #005665 )',
    transitionProperty: 'padding',
    transitionDuration: '300ms',
    minHeight: '160px',
    display: 'flex',
    justifyContent: 'center'
  },
  [`& .masked`]: {
    backgroundImage: 'url("/static/images/logo/logo_small.svg")',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
    width: '25px',
    height: '36px',
    transitionProperty: 'width, height, background',
    transitionDuration: '300ms'
  },
  [`& .masked.full`]: {
    width: '125px',
    height: '52.5px',
    backgroundImage: 'url("/static/images/logo/full_logo_small.svg")',
    transitionProperty: 'width, height, background',
    transitionDuration: '300ms'
  },
  [`&.wide`]: {
    padding: '50px 63px 0 63px',
    transitionProperty: 'padding',
    transitionDuration: '300ms'
  }
}));

export const SidebarLogo: FC<SidebarLogoProps> = ({ full = false }) => {
  const { getHomePage } = useAuthContext();
  const homepage = getHomePage();
  const nav = useNavigate();
  const [goToHomePage, setGoToHomePage] = useState(false);

  useEffect(() => {
    if (!homepage) return;
    if (!goToHomePage) return;
    nav(homepage);
    setGoToHomePage(false);
  }, [goToHomePage]);

  return (
    <>
      <SidebarLogoWrapper onClick={() => setGoToHomePage(true)} className={full ? 'wide' : ''}>
        <div className={`masked${full ? ' full' : ''}`}></div>
      </SidebarLogoWrapper>
    </>
  );
};
